import { Card, Button, Row, Form, Col } from "react-bootstrap";
import { PageTitleConstants } from "../../Constants";
import {
  PageHeader,
  FormControl,
  DateTimeControl,
  SelectControl,
  TextAreaControl
} from "wup-module1-base";

function CalendarForm() {
  const actualDate = new Date().toISOString().slice(0, 10);
  const listOfTypesTerms = [
    {name: 'Termin indywidualny', value: 1},
    {name: 'Termin grupowy', value: 2},
    {name: 'Termin zajęty', value: 3},
  ];
  const listOfServices = [
    {name: 'Oferta ekskluzywna', value: 1},
    {name: 'Konsultacje', value: 2},
    {name: 'Spotkanie z klientem', value: 3},
  ];
  const listOfMeetingTypes = [
    {name: 'Stacjonarnie', value: 1},
    {name: 'Przez internet', value: 2},
  ];
  const listOfTimeSlots = [
    {name: '90 minut', value: 1},
    {name: '60 minut', value: 2},
    {name: '30 minut', value: 3},
    {name: '10 minut', value: 4},
  ];
  const listOfLocalizations = [
    {name: 'Białystok', value: 1},
    {name: 'Kraków', value: 2},
    {name: 'Warszawa', value: 3},
    {name: 'Poznań', value: 4},
  ];
  
    return (
      <>
        <PageHeader content={`${PageTitleConstants.Calendar} ${PageTitleConstants.CalendarForm}`} />
        <Card>
          <Card.Body className="pt-4-5">
            {/* <FormControl> */}
              <SelectControl
                label="Rodzaj terminu*"
                options={listOfTypesTerms}
              />
              <SelectControl
                label="Usluga*"
                options={listOfServices}
              />
              <SelectControl
                label="Rodzaj spotkania*"
                options={listOfMeetingTypes}
              />
			  <Row>
				<Col md={3}>
					<DateTimeControl
						label="Data spotkania*"
						min={actualDate}
						className=""
					/>
				</Col>
				<Col md={2}>
					<DateTimeControl
						label="Od*"
						type="time"
						className=""
					/>
				</Col>
				<Col md={2}>
					<DateTimeControl
						label="Do*"
						type="time"
						className=""
					/>
				</Col>
			  </Row>
              <SelectControl
                label="Slot czasowy*"
                options={listOfTimeSlots}
              />
              <SelectControl
                label="Lokalizacja*"
                options={listOfLocalizations}
              />
              <TextAreaControl
                label="Opis"
                onChange={() => {}}
              />
              <div className="d-flex justify-content-between p-3">
                <div>
                  <p>
                    <b>*</b> - pola obowiązkowe
                  </p>
                </div>
                <div>
                  <Button 
				  	variant="primary"
					onclick={() => {}}
				  >
					Zapisz
				</Button>
                </div>
              </div>
            {/* </FormControl> */}
          </Card.Body>
        </Card>
      </>
    );
}
  
export default CalendarForm;
